import { Box, Grid, Typography } from '@mui/material';
import { memo } from 'react';

import { GroupStatusIcon } from '../../components/StatusIndicators';
import { isGroupComplete } from '../../utils/completionUtils';
import { INF_STATISTIC_FIELD_LABELS } from '../constants';

interface ResidualsProps {
  residuals: number[];
  residualsCurve: number[];
}

export const Residuals = memo(function Residuals(props: ResidualsProps) {
  const { residuals, residualsCurve } = props;

  return (
    <Grid id="inf-residuals" container spacing={2} marginBottom={3}>
      <Grid item xs={12}>
        <Box display="flex" alignItems="center" gap={1}>
          <GroupStatusIcon
            isComplete={isGroupComplete(residuals, residualsCurve)}
          />
          <Typography my={2} fontWeight={600}>
            Normalidade dos Resíduos
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Typography mb={1} color="#707070">
          Resíduos entre -1 e +1
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography variant="caption" color="text.secondary">
          {INF_STATISTIC_FIELD_LABELS.residuals_curve_normal}
        </Typography>
        <Typography>
          {residualsCurve[0] != null ? `${residualsCurve[0]} %` : '-'}
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography variant="caption" color="text.secondary">
          {INF_STATISTIC_FIELD_LABELS.residuals_model}
        </Typography>
        <Typography>
          {residuals[0] != null ? `${residuals[0]} %` : '-'}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography my={1} color="#707070">
          Resíduos entre -1,64 e +1,64
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography variant="caption" color="text.secondary">
          {INF_STATISTIC_FIELD_LABELS.residuals_curve_normal}
        </Typography>
        <Typography>
          {residualsCurve[1] != null ? `${residualsCurve[1]} %` : '-'}
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography variant="caption" color="text.secondary">
          {INF_STATISTIC_FIELD_LABELS.residuals_model}
        </Typography>
        <Typography>
          {residuals[1] != null ? `${residuals[1]} %` : '-'}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography my={1} color="#707070">
          Resíduos entre -1,96 e +1,96
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography variant="caption" color="text.secondary">
          {INF_STATISTIC_FIELD_LABELS.residuals_curve_normal}
        </Typography>
        <Typography>
          {residualsCurve[2] != null ? `${residualsCurve[2]} %` : '-'}
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography variant="caption" color="text.secondary">
          {INF_STATISTIC_FIELD_LABELS.residuals_model}
        </Typography>
        <Typography>
          {residuals[2] != null ? `${residuals[2]} %` : '-'}
        </Typography>
      </Grid>
    </Grid>
  );
});
